import type { SetupTranslation } from './en';

/** Arabic (Modern Standard). Pending review by native speakers, as the note in the interface says. */
export const setupAr: SetupTranslation = {
  models: {
    intro:
      'يتيح مفتاح الذكاء الاصطناعي لوكلاء الذكاء الاصطناعي لديك كتابة الإجابات. تحصل عليه من شركة ذكاء اصطناعي مثل OpenAI أو Anthropic أو Google. الصقه هنا وسنختبره لك. تُخزَّن المفاتيح مشفّرة ولا تُعرض مرة أخرى.',
    empty:
      'أضف أول مفتاح ذكاء اصطناعي ليجيب وكلاؤك بذكاء اصطناعي حقيقي. من دونه لا يمكنهم استخدام سوى المفاتيح التي يحتفظ بها الخادم أصلًا (المذكورة أدناه) والنموذج التجريبي دون اتصال الذي يعطي ردودًا جاهزة.',
    addDescription:
      'اختر الجهة التي أعطتك المفتاح، والصقه، واختر نموذجًا. نحفظه مشفّرًا ونختبره فورًا.',
    model: 'النموذج',
    modelHint: 'نموذج الذكاء الاصطناعي الذي يُختبر به المفتاح. النموذج الموصى به بداية جيدة.',
    recommended: 'موصى به',
    customModel: 'نموذج آخر…',
    customLabel: 'اسم النموذج',
    customHint: 'اكتب اسم النموذج تمامًا كما يكتبه المزوّد.',
    customServerHint: 'اكتب اسم نموذج يقدّمه خادمك، تمامًا كما يكتبه الخادم.',
    tiers: { fast: 'سريع ومنخفض التكلفة', balanced: 'متوازن', capable: 'الأكثر قدرة' },
    serverAddress: 'عنوان الخادم',
    serverAddressHint: 'عنوان https:// لخادمك المتوافق مع OpenAI، مثل https://llm.example.com/v1.',
    labelHint: 'اسم لك ولفريقك، مثل «OpenAI للإنتاج». إن تركته فارغًا نستخدم اسم المزوّد.',
    moreOptions: 'خيارات إضافية',
    testNote:
      'بعد الحفظ نرسل رسالة اختبار صغيرة من بضع كلمات إلى المزوّد للتأكد من أن المفتاح يعمل. تكلفتها جزء ضئيل جدًا من السنت.',
    saveAndTest: 'حفظ واختبار',
    errors: { model: 'اختر نموذجًا أو اكتب اسمه.' },
    addedOn: 'أُضيف {{date}}',
    columns: { lastTest: 'آخر اختبار' },
    lastTest: { never: 'لم يُختبر بعد', ok: 'يعمل' },
    test: 'اختبار المفتاح',
    testLabel: 'اختبر مفتاح {{label}}',
    testTitle: 'اختبار مفتاح {{label}}',
    testDescription:
      'نرسل رسالة صغيرة واحدة إلى مزوّد الذكاء الاصطناعي ونعرض ما عاد منه. لا يُضاف شيء إلى محادثات عملائك.',
    testing: 'جارٍ اختبار المفتاح…',
    testingWith: 'جارٍ اختبار المفتاح بالنموذج {{model}}…',
    testAgain: 'اختبر مرة أخرى',
    testedWith: 'اختُبر بالنموذج',
    probe: {
      ok: { title: 'المفتاح يعمل', body: 'أجاب الذكاء الاصطناعي عن رسالة الاختبار.' },
      wrong_key: {
        title: 'لم يقبل المزوّد المفتاح',
        body: 'تحقق من أنك نسخته كاملًا وأنه يخص هذا المزوّد. يمكنك استبداله من القائمة.',
      },
      no_credit: {
        title: 'نفد الرصيد',
        body: 'المفتاح حقيقي لكن الحساب لا رصيد فيه. أضف رصيدًا لدى المزوّد ثم اختبر مرة أخرى.',
      },
      model_not_found: {
        title: 'النموذج غير موجود',
        body: 'لا يعرف المزوّد اسم هذا النموذج. اختر نموذجًا آخر من القائمة أو تحقق من الإملاء.',
      },
      network: {
        title: 'تعذّر الوصول إلى المزوّد',
        body: 'إن حدّدت عنوان خادم فتحقق منه، ثم حاول مرة أخرى بعد دقيقة.',
      },
      blocked: {
        title: 'عنوان الخادم هذا غير مسموح به',
        body: 'استخدم عنوان https:// عامًا، أو اسأل من يشغّل خادم Hamnivo لديك.',
      },
      rate_limited: {
        title: 'يطلب المزوّد التمهّل',
        body: 'انتظر دقيقة ثم اختبر مرة أخرى.',
      },
      unavailable: {
        title: 'يواجه المزوّد مشكلة',
        body: 'حاول مرة أخرى بعد بضع دقائق.',
      },
      unknown: {
        title: 'لم ينجح الاختبار',
        body: 'لا نعرف السبب. حاول مرة أخرى أو تحقق من المفتاح والنموذج لدى المزوّد.',
      },
    },
    replace: {
      action: 'استبدال المفتاح',
      label: 'استبدل مفتاح {{label}}',
      title: 'استبدال مفتاح {{label}}',
      description:
        'الصق المفتاح الجديد. يواصل الوكلاء الذين يستخدمون هذا الاتصال عملهم بالمفتاح الجديد، ويتوقف القديم عن العمل. قد يُطلب منك تسجيل الدخول مرة أخرى أولًا.',
      newKey: 'مفتاح API جديد',
      newKeyHint: 'ينتهي المفتاح الحالي بـ {{hint}}. يُخزَّن الجديد مشفّرًا ولا يُعرض مرة أخرى.',
      submit: 'استبدال واختبار',
      replaced: 'استُبدل مفتاح {{label}}.',
      done: 'استُبدل المفتاح. ينتهي المفتاح الجديد بـ {{hint}}.',
    },
    server: {
      title: 'المفاتيح على هذا الخادم',
      description:
        'يمكن لمن يشغّل خادم Hamnivo لديك أن يمنحه مفاتيح ذكاء اصطناعي خاصة به. يمكن للوكلاء استخدامها دون اتصال هنا. نعرض فقط هل المفتاح مضبوط، ولا نعرض المفتاح نفسه أبدًا.',
      loading: 'جارٍ تحميل إعدادات الخادم',
      set: 'المفتاح مضبوط',
      notSet: 'لا يوجد مفتاح',
      jev: 'Jev',
      jevHint: 'يوجّه الأسئلة ويدقّق الإجابات. اختياري.',
      jevOn: 'مُعدّ',
      jevOff: 'غير مُعدّ',
      embeddings: 'البحث في المعرفة',
      embeddingsMock:
        'مطابقة بسيطة للكلمات، تكفي للتجربة. البحث بالمعنى يحتاج مفتاح OpenAI أو Google على الخادم.',
      embeddingsReady: 'يبحث بالمعنى باستخدام {{provider}}.',
      embeddingsMissing: 'مضبوط لاستخدام {{provider}} لكن الخادم لا يملك مفتاحًا له.',
      embeddingsOn: 'بالمعنى',
      embeddingsBasic: 'أساسي',
      embeddingsNotReady: 'غير جاهز',
    },
  },
  home: {
    guided: 'افتح الإعداد الموجَّه',
    steps: {
      brand: {
        title: 'أضف علامتك التجارية وموقعك',
        description: 'سمِّ علامتك التجارية واسمح بموقعك لتُحمَّل المحادثة فيه.',
      },
      install: {
        title: 'ضع المحادثة على موقعك',
        description: 'الصق الشيفرة في موقعك وافتح صفحة منه. سيلاحظ Studio ذلك تلقائيًا.',
      },
      engine: {
        title: 'اربط محرك المحادثة',
        description: 'اربطه مرة واحدة لكل علامة تجارية لتصل المحادثات إلى فريقك.',
      },
      aikey: {
        title: 'أضف مفتاح ذكاء اصطناعي',
        description:
          'يحتاج وكلاء الذكاء الاصطناعي لديك إلى مفتاح من شركة ذكاء اصطناعي مثل OpenAI أو Anthropic أو Google ليكتبوا إجابات حقيقية.',
      },
      agent: {
        title: 'انشر وكيل ذكاء اصطناعي',
        description:
          'لا يجيب مساعدك العملاء إلا بعد نشره بنموذج ذكاء اصطناعي حقيقي، وليس بالنموذج التجريبي دون اتصال.',
      },
      team: {
        title: 'ادعُ زميلًا',
        description: 'أضف من سيجيبون عن المحادثات معك.',
      },
    },
  },
  leave: {
    title: 'المغادرة دون حفظ؟',
    description: 'لديك تغييرات غير محفوظة. إن غادرت الآن فستضيع.',
    keep: 'متابعة التحرير',
    discard: 'تجاهل التغييرات',
  },
  appearance: {
    open: 'المظهر والصياغة',
    openLabel: 'غيّر مظهر محادثة {{name}} وصياغتها',
    title: 'مظهر محادثة {{name}} وصياغتها',
    description:
      'اختر اللون والشعار والكلمات التي يراها العملاء. تتغير الصورة بجانب الحقول أثناء الكتابة، ولا يصل شيء إلى العملاء حتى تحفظ.',
    loading: 'جارٍ تحميل مظهر المحادثة',
    previewTitle: 'ما سيراه العملاء',
    previewNote:
      'صورة للمحادثة. استخدم «اختبار المحادثة» في العلامة التجارية لتجربة المحادثة الحقيقية.',
    previewLabel: 'معاينة المحادثة',
    previewLanguage: 'اللغة',
    previewState: 'العرض عندما',
    stateOnline: 'الفريق متصل',
    stateAway: 'الفريق غائب',
    colour: {
      label: 'اللون الرئيسي',
      hint: 'يُستخدم للشريط العلوي للمحادثة وزر الإرسال ورسائل عملائك. رمز لون مثل #D17B00.',
      pick: 'اختر اللون الرئيسي',
      format: 'استخدم رمز لون يبدأ بعلامة # ويتبعها ستة أحرف أو أرقام، مثل #D17B00.',
      text: 'النص على هذا اللون يصعب قراءته.',
      faint: 'هذا اللون قريب جدًا من الأبيض فلا يبرز في صفحة الويب.',
      suggest: 'لون أغمق قليلًا، {{colour}}، أسهل في القراءة.',
      apply: 'استخدم {{colour}}',
    },
    logo: {
      label: 'عنوان ويب الشعار',
      hint: 'عنوان https:// لصورة شعارك، مثل https://example.com/logo.png. يظهر صغيرًا بجانب اسم علامتك التجارية.',
    },
    radius: {
      label: 'استدارة الزوايا',
      value: '{{px}} بكسل',
      hint: '0 يعني زوايا حادة. الأرقام الأكبر أكثر استدارة.',
    },
    greeting: {
      label: 'التحية',
      hint: 'أول ما يقرؤه العملاء. اتركها فارغة لاستخدام تحية Hamnivo. اكتب الإنجليزية أولًا: تعود إليها اللغات الأخرى.',
    },
    offline: {
      label: 'رسالة عند عدم وجود أحد متصل',
      hint: 'يقرؤها العملاء عندما يطلبون شخصًا خارج ساعات عملك. اكتب {when} حيث يجب أن يظهر وقت عودة فريقك. اتركها فارغة لاستخدام رسالة Hamnivo.',
    },
    csat: {
      label: 'اطلب من العملاء تقييم المحادثة',
      hint: 'عند انتهاء المحادثة يمكن للعملاء إعطاء من 1 إلى 5 نجوم وترك تعليق.',
    },
    privacy: {
      label: 'عنوان ويب سياسة الخصوصية',
      hint: 'يظهر رابطًا أسفل المحادثة، مثل https://example.com/privacy.',
    },
    urlProblem: 'استخدم عنوان ويب يبدأ بـ https:// ولا يحتوي على اسم مستخدم أو كلمة مرور.',
    englishFirst: 'اكتب النص الإنجليزي أولًا. تعود إليه اللغات الأخرى.',
    reset: 'إعادة ضبط',
    save: 'حفظ المظهر',
    saved: 'حُفظ مظهر محادثة {{name}}.',
  },
  testChat: {
    open: 'اختبار المحادثة',
    openLabel: 'جرّب محادثة {{name}}',
    needsEngine: 'اربط محرك المحادثة لهذه العلامة التجارية أولًا.',
    title: 'اختبار محادثة {{name}}',
    description:
      'هذه محادثتك الحقيقية وهي تعمل داخل Studio. أرسل رسالة لترى شكلها وما يجيب به الذكاء الاصطناعي.',
    frameTitle: 'اختبار محادثة {{name}}',
    noteReal: 'هي المحادثة الحقيقية: يجيب الذكاء الاصطناعي بمفتاحك الحقيقي وبما يعرفه.',
    noteReports: 'تُستبعد محادثات الاختبار من تقاريرك وعدّاداتك.',
    noteUsage: 'تستهلك من باقتك مثل أي محادثة، وقد تظهر في صندوق الوارد.',
  },
  brand: 'العلامة التجارية',
  hours: {
    nav: 'ساعات العمل',
    title: 'ساعات العمل',
    description:
      'أخبر العملاء متى يجيب فريقك. خارج هذه الساعات تقول المحادثة إن أحدًا غير متصل ومتى تعودون. يجيب مساعد الذكاء الاصطناعي في أي ساعة.',
    edit: 'تعديل ساعات العمل',
    notSet: 'غير مضبوطة. إلى أن تضبط الساعات لن تقول المحادثة أبدًا إن شخصًا متاح.',
    closedAlways: 'مغلق كل يوم',
    closedDays: 'أيام الإغلاق: {{n}}',
    to: 'إلى',
    loading: 'جارٍ تحميل ساعات العمل',
    noBrands: {
      title: 'لا توجد علامات تجارية بعد',
      description: 'ساعات العمل تخص علامة تجارية. أضف علامة تجارية أولًا.',
      action: 'اذهب إلى العلامات التجارية',
    },
    timezone: {
      label: 'المنطقة الزمنية',
      hint: 'الساعات أدناه بهذه المنطقة الزمنية، أينما كان عملاؤك.',
    },
    presets: {
      weekdays: 'من الاثنين إلى الجمعة، من 9:00 إلى 17:00',
      everyday: 'كل يوم، طوال اليوم',
      closed: 'مغلق كل يوم',
    },
    week: {
      title: 'الساعات الأسبوعية',
      hint: 'حدّد الأيام التي يجيب فيها فريقك واضبط الأوقات. وقت إغلاق 12:00 ص يعني منتصف الليل في نهاية ذلك اليوم.',
      open: 'مفتوح',
      opens: 'يفتح',
      closes: 'يغلق',
      add: 'أضف وقتًا آخر',
      remove: 'احذف هذا الوقت يوم {{day}}',
    },
    holidays: {
      title: 'أيام الإغلاق',
      description:
        'العطلات الرسمية وأيام كاملة أخرى لا يجيب فيها أحد. في هذه الأيام تقول المحادثة إن أحدًا غير متصل.',
      date: 'اليوم',
      add: 'أضف يومًا',
      remove: 'احذف {{date}}',
      none: 'لا توجد أيام إغلاق.',
    },
    problems: {
      time: 'أدخل وقت فتح ووقت إغلاق ليوم {{day}}.',
      order: 'يوم {{day}}، يجب أن يكون الإغلاق بعد الفتح.',
      overlap: 'يوم {{day}}، يجب ألا تتداخل الأوقات.',
      zone: 'اختر منطقة زمنية من القائمة.',
      date: 'أحد أيام الإغلاق ليس تاريخًا.',
    },
    save: 'حفظ الساعات',
    saved: 'حُفظت ساعات عمل {{name}}.',
    reset: 'إعادة ضبط',
    unsaved: 'لديك تغييرات غير محفوظة.',
    noPermission: 'اطلب من مالك أو مسؤول تغيير ساعات العمل.',
    remove: {
      action: 'إزالة الساعات',
      title: 'إزالة ساعات {{name}}؟',
      body: 'عندها لن تقول المحادثة أبدًا إن شخصًا متاح. يمكنك ضبط الساعات مجددًا في أي وقت.',
      confirm: 'إزالة الساعات',
      done: 'أُزيلت ساعات {{name}}.',
    },
  },
  identity: {
    nav: 'تسجيل دخول العملاء',
    title: 'تسجيل دخول العملاء',
    description:
      'دع موقعك يخبر Hamnivo من هو العميل المسجَّل دخوله ليرى محادثاته على كل جهاز. يتولى مطوّر إعداد هذا؛ وإن كان عملاؤك لا يسجّلون الدخول إلى موقعك فيمكنك تجاوزه.',
    guide: 'اقرأ دليل المطوّرين',
    loading: 'جارٍ تحميل مفاتيح تسجيل دخول العملاء',
    noBrands: 'تسجيل دخول العملاء يخص علامة تجارية. أضف علامة تجارية أولًا.',
    noPermission: 'اطلب من مالك أو مسؤول إدارة هذه المفاتيح.',
    empty: {
      title: 'لا توجد مفاتيح بعد',
      description:
        'يوقّع خادم موقعك مذكرة قصيرة عن العميل بمفتاح. أنشئ المفتاح هنا وسلّمه إلى مطوّرك.',
    },
    columns: {
      name: 'اسم المفتاح',
      type: 'النوع',
      status: 'الحالة',
      added: 'أُضيف',
      actions: 'الإجراءات',
    },
    algs: {
      HS256: 'سرّ مشترك (HS256)',
      ES256: 'مفتاح عام (ES256)',
      EdDSA: 'مفتاح عام (EdDSA)',
      RS256: 'مفتاح عام (RS256)',
    },
    status: { active: 'نشط', retiring: 'ينتهي قريبًا', revoked: 'مُلغى' },
    create: {
      action: 'إنشاء مفتاح',
      title: 'إنشاء مفتاح تسجيل دخول العملاء',
      description:
        'تحتاج إدارة المفاتيح إلى التحقق بخطوتين وتسجيل دخول حديث. قد يُطلب منك تسجيل الدخول مرة أخرى.',
      kind: 'أي نوع من المفاتيح؟',
      secret: 'سرّ مشترك',
      secretHint: 'ينشئه Hamnivo لك ويعرضه مرة واحدة. أسهل طريقة للبدء.',
      public: 'مفتاح عام',
      publicHint: 'تحتفظ بالمفتاح الخاص على خادمك وتعطي Hamnivo النصف العام فقط.',
      alg: 'نوع التوقيع',
      jwk: {
        label: 'المفتاح العام (JWK)',
        hint: 'الصق المفتاح العام بصيغة JSON. لا تلصق مفتاحًا خاصًا أبدًا: يرفضه Hamnivo.',
        json: 'هذا ليس JSON صالحًا.',
        object: 'الصق مفتاحًا واحدًا ككائن JSON.',
        private: 'يبدو هذا مفتاحًا خاصًا. الصق النصف العام فقط.',
      },
      name: 'اسم المفتاح',
      nameHint: 'أحرف وأرقام ونقطة وشرطة سفلية وشرطة، حتى 64. إن تركته فارغًا اختار Hamnivo اسمًا.',
      nameInvalid: 'استخدم أحرفًا وأرقامًا ونقطة وشرطة سفلية وشرطة فقط، حتى 64.',
      submitSecret: 'إنشاء السر',
      submitPublic: 'تسجيل المفتاح',
    },
    rotate: {
      action: 'استبدال',
      label: 'استبدل المفتاح {{kid}}',
      title: 'استبدال المفتاح {{kid}}',
      description:
        'ننشئ مفتاحًا جديدًا من النوع نفسه ونعلّم هذا المفتاح بأنه ينتهي قريبًا. يظل المفتاح الذي ينتهي قريبًا يعمل، فيمكن لخادمك الانتقال دون انقطاع.',
      retireFailed:
        'أُنشئ المفتاح الجديد لكن تعذّر تعليم {{kid}} بأنه ينتهي قريبًا. جرّب «استبدال» مرة أخرى في صفّه، أو ألغِه عندما لا يستخدمه أحد.',
    },
    revoke: {
      action: 'إلغاء',
      label: 'ألغِ المفتاح {{kid}}',
      title: 'إلغاء المفتاح {{kid}}؟',
      body: 'يُرفض كل ما وُقّع بهذا المفتاح من الآن. افعل ذلك فقط إذا كنت متأكدًا أن خادمك لم يعد يستخدمه.',
      confirm: 'إلغاء المفتاح',
      done: 'أُلغي المفتاح {{kid}}.',
    },
    how: {
      title: 'تغيير مفتاح دون انقطاع',
      description: 'افعل ذلك بهذا الترتيب كي لا يُحرم العملاء أبدًا.',
      step1: 'اضغط «استبدال» على المفتاح المستخدم. يُنشأ مفتاح جديد ويُعلَّم القديم بأنه ينتهي قريبًا.',
      step2: 'سلّم المفتاح الجديد إلى مطوّرك ليحوّل خادم موقعك إليه.',
      step3: 'عندما لا يستخدم أحد المفتاح القديم بعد الآن، اضغط «إلغاء» عليه.',
    },
    created: 'أُنشئ المفتاح {{kid}}.',
    reveal: { title: 'سرّك الجديد', label: 'السر الخاص بالمفتاح {{kid}}' },
  },
  teams: {
    nav: 'فرق الدعم',
    title: 'فرق الدعم',
    description: 'من في كل فريق. الفرق هي ما تُسلَّم إليه المحادثات. أضف أشخاصًا أو أزلهم هنا.',
    loading: 'جارٍ تحميل الفرق',
    noPermission: 'اطلب من مالك أو مسؤول تغيير الفرق.',
    empty: {
      title: 'لا توجد فرق بعد',
      description: 'الفريق مجموعة أشخاص يجيبون عن المحادثات معًا، مثل «الدعم» أو «المبيعات».',
    },
    create: 'إنشاء فريق',
    createTitle: 'إنشاء فريق',
    createDescription: 'أعطِ الفريق اسمًا. تضيف أعضاءه بعد ذلك.',
    name: 'اسم الفريق',
    nameHint: 'مثل «الدعم» أو «المبيعات».',
    nameRequired: 'أعطِ الفريق اسمًا.',
    created: 'أُنشئ الفريق {{name}}.',
    archived: 'مؤرشف',
    count: 'عدد الأشخاص في هذا الفريق: {{n}}',
    noMembers: 'لا أحد في هذا الفريق بعد.',
    remove: 'أخرِج {{name}} من {{team}}',
    removed: 'أُخرج {{name}} من {{team}}.',
    addLabel: 'أضف شخصًا',
    choose: 'اختر شخصًا',
    everyone: 'الجميع في هذا الفريق بالفعل',
    add: 'أضف إلى الفريق',
    added: 'أُضيف {{name}} إلى {{team}}.',
    rules: 'تصل المحادثات إلى الفرق عبر قواعد كل علامة تجارية.',
    rulesLink: 'افتح القواعد',
  },
  install: {
    platforms: {
      html: 'أي موقع',
      wordpress: 'WordPress',
      woocommerce: 'WooCommerce',
      shopify: 'Shopify',
      whmcs: 'WHMCS',
      wix: 'Wix',
      squarespace: 'Squarespace',
      webflow: 'Webflow',
      'google-tag-manager': 'Google Tag Manager',
      react: 'React',
      vue: 'Vue',
      nextjs: 'Next.js',
    },
  },
  onboarding: {
    title: 'مرحبًا بك في Hamnivo',
    description:
      'أعدّ كل شيء في دقائق. يمكن تخطي أي خطوة وإنجازها لاحقًا، ولا يضيع شيء مما فعلته إن غادرت.',
    later: 'الإنهاء لاحقًا',
    loading: 'جارٍ تحميل إعدادك',
    railLabel: 'خطوات الإعداد',
    count: 'تمت معالجة {{done}} من {{total}} خطوات',
    stepOf: 'الخطوة {{n}} من {{total}}',
    back: 'رجوع',
    skip: 'تخطَّ هذه الخطوة',
    continue: 'متابعة',
    needsBrand: 'تحتاج هذه الخطوة إلى علامة تجارية. أضف واحدة أولًا.',
    toBrand: 'أضف علامة تجارية',
    state: { done: 'تمّت', skipped: 'تم تخطيها', todo: 'لم تتم بعد' },
    steps: {
      workspace: {
        name: 'مساحة العمل',
        title: 'مساحة عملك',
        description: 'هنا يوجد كل ما يخص عملك.',
      },
      brand: {
        name: 'العلامة التجارية والموقع',
        title: 'علامتك التجارية وموقعك',
        description:
          'لكل علامة تجارية محادثتها ومواقعها المسموح بها ومساعد الذكاء الاصطناعي الخاص بها. أخبرنا باسمها وأين ستظهر المحادثة.',
      },
      engine: {
        name: 'محرك المحادثة',
        title: 'اربط محرك المحادثة',
        description: 'ينقل محرك المحادثة رسائل عملائك إلى فريقك. يُعدّ نفسه بنفسه.',
      },
      aikey: {
        name: 'مفتاح الذكاء الاصطناعي',
        title: 'أضف مفتاح ذكاء اصطناعي',
        description:
          'يتيح مفتاح الذكاء الاصطناعي لوكلائك كتابة الإجابات. الصق مفتاحًا من شركة ذكاء اصطناعي وسنتحقق من أنه يعمل.',
      },
      testchat: {
        name: 'اختبار المحادثة',
        title: 'جرّب المحادثة بنفسك',
        description: 'أرسل رسالة إلى محادثتك قبل أن يراها أي عميل.',
      },
      install: {
        name: 'التثبيت',
        title: 'ضع المحادثة على موقعك',
        description: 'اختر الأداة التي بُني بها موقعك ثم انسخ الشيفرة إليه.',
      },
      team: {
        name: 'الفريق',
        title: 'ادعُ فريقك',
        description: 'أحضر من سيجيبون عن المحادثات معك. يمكنك فعل ذلك لاحقًا.',
      },
    },
    workspace: {
      ready: 'مساحة عملك {{name}} جاهزة.',
    },
    brand: {
      existing: 'العلامة التجارية المراد إعدادها',
      existingHint: 'هذه العلامات التجارية موجودة أصلًا في مساحة عملك.',
      use: 'تابع مع {{name}}',
      addAnother: 'أضف علامة تجارية أخرى',
      website: 'موقعك',
      websiteHint:
        'حيث ستظهر المحادثة، مثل noor.example. هذا الموقع وحده يمكنه عرض المحادثة. يمكنك تغييره لاحقًا.',
      create: 'إنشاء العلامة التجارية',
      websiteInvalid: '{{value}} ليس عنوان موقع. اكتبه هكذا: noor.example أو https://noor.example.',
      useExisting: 'استخدم علامة تجارية لدي',
    },
    engine: {
      checking: 'جارٍ فحص محرك المحادثة…',
      working: 'جارٍ إعداد محرك المحادثة لـ {{name}}. يستغرق هذا لحظات.',
      ready: 'محرك المحادثة جاهز.',
      retry: 'حاول مرة أخرى',
      disabled: 'الاتصال متوقف. اطلب من مسؤول تشغيله.',
      slow: 'يستغرق هذا وقتًا أطول من المعتاد. يمكنك الانتظار هنا، أو تخطي هذه الخطوة وربط محرك المحادثة لاحقًا من «العلامات التجارية والتثبيت».',
      stopped: 'توقف الإعداد: {{error}} حاول مرة أخرى: سيكمل من حيث توقف.',
      cancelled: 'أُغلقت نافذة تسجيل الدخول، لذلك لم يبدأ الإعداد.',
    },
    aikey: {
      noPermission:
        'لا يضيف مفتاح الذكاء الاصطناعي إلا من يدير الاتصالات. اطلب من مالك أو مسؤول، أو تخطَّ هذه الخطوة.',
      serverKey:
        'يحتفظ هذا الخادم أصلًا بمفتاح ذكاء اصطناعي خاص به، فيمكن لوكلائك الإجابة حتى من دون مفتاح هنا. أضف مفتاحك لاستخدام حسابك الخاص.',
      have: 'لديك مفتاح ذكاء اصطناعي بالفعل. اختبره للتأكد من أنه يعمل.',
    },
    testchat: {
      toEngine: 'اذهب إلى خطوة محرك المحادثة',
      done: 'تعمل، تابع',
    },
    install: {
      platform: 'بأي أداة بُني موقعك؟',
      platformHint: 'نضع رابط دليلها. إن لم تكن متأكدًا فأبقِ «أي موقع».',
      guide: 'افتح دليل التثبيت: {{platform}}',
      where: 'أين توضع هذه الشيفرة؟',
      whereBody:
        'الصقها في كل صفحة يجب أن تظهر فيها المحادثة، قبل وسم </body> الختامي مباشرة. في منشئ المواقع ابحث عن مكان لإضافة شيفرة مخصصة أو سكربت في التذييل. يبيّن الدليل أعلاه المكان بالضبط.',
      addWebsite: 'أضف موقعك',
      status: {
        waiting: 'بانتظار موقعك',
        waitingBody:
          'الصق الشيفرة، واحفظ موقعك أو انشره، ثم افتح أي صفحة منه. يتغير هذا تلقائيًا عندما تُحمَّل المحادثة هناك.',
        check: 'تحقق الآن',
        found: 'المحادثة موجودة على موقعك',
        foundBody: 'افتح صفحة من موقعك وأرسل رسالة من المحادثة: ستظهر في صندوق الوارد.',
        lastSeen: 'آخر ظهور {{time}}',
        help: 'لا تظهر؟',
        helpExact: 'يجب أن تكون الصفحة على أحد المواقع أعلاه تمامًا، بنفس https و www.',
        helpCache:
          'افتح الصفحة بعد حفظها، أو امسح ذاكرة التخزين المؤقت لموقعك، لتستخدم الشيفرة الجديدة.',
        helpPolicy:
          'إذا كانت لموقعك سياسة أمان للمحتوى، فيجب أن تسمح بالبرامج النصية والإطارات والاتصالات من Hamnivo.',
        onWebsite: 'على موقعك',
        notSeen: 'لم تُرَ بعد',
      },
      done: 'أضفت الشيفرة',
    },
    team: {
      none: 'لا أحد غيرك هنا بعد. يمكنك دعوة أشخاص الآن أو لاحقًا.',
      some: 'الأشخاص في مساحة عملك غيرك: {{people}}. الدعوات المرسلة: {{invited}}.',
      invite: 'ادعُ زميلًا',
      finish: 'إنهاء الإعداد',
      noPermission: 'اطلب من مالك أو مسؤول دعوة الأشخاص.',
    },
    finished: {
      title: 'كل شيء جاهز',
      titleOpen: 'حُفظ الإعداد',
      description: 'اكتمل كل شيء. يمكنك تغيير أي منه لاحقًا من القائمة.',
      descriptionOpen:
        'الخطوات المتبقية: {{n}}. يمكنك إنجازها الآن أو في أي وقت لاحقًا؛ وتتابعها القائمة في الصفحة الرئيسية.',
      doSkipped: 'افعلها الآن',
      doTodo: 'افعلها الآن',
      go: 'اذهب إلى الرئيسية',
    },
  },
};
